import {Component, inject, signal, Signal} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {CardComponent} from '../card/card.component';
import {MatIcon} from '@angular/material/icon';
import {MatDialog} from '@angular/material/dialog';
import {
  CustomerNewsletterInfoModalComponent
} from '../customer-newsletter-info-modal/customer-newsletter-info-modal.component';
import {LoadingIconComponent} from '../loading-icon/loading-icon.component';
import {CustomerService, NewsletterSubscriptions} from '../../core/services/customer.service';
import {HubspotService} from '../../core/services/hubspot.service';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

@Component({
  selector: 'app-customer-newsletter-form',
  standalone: true,
  imports: [
    MatButton,
    CardComponent,
    MatIcon,
    LoadingIconComponent,
    MatProgressSpinner,
  ],
  templateUrl: './customer-newsletter-form.component.html',
  styleUrl: './customer-newsletter-form.component.scss'
})
export class CustomerNewsletterFormComponent {
  private customerService = inject(CustomerService);
  private hubspotService = inject(HubspotService);
  private dialog = inject(MatDialog);

  selectedCustomerNewsletter: Signal<{loading: boolean, data: NewsletterSubscriptions|null}> = signal({data: null, loading: false});

  loadingSubscribeToNewsletter = signal(false);
  loadingSubscribeToOneToTwoEmailsAWeek = signal(false);

  constructor() {
    this.selectedCustomerNewsletter = this.customerService.selectedCustomerNewsletter;
  }

  openNewsletterInfoModal() {
    const dialogRef = this.dialog.open(CustomerNewsletterInfoModalComponent, {
      width: '700px',
      maxWidth: '90vw',
    });
  }

  async subscribeToNewsletter() {
    const vismaId = this.customerService.selectedCustomer().customer?.vismaId;
    if (vismaId) {
      this.loadingSubscribeToNewsletter.set(true);
      await this.hubspotService.subscribeCustomerToNewsletter(vismaId, true, false);
      this.loadingSubscribeToNewsletter.set(false);
    }
  }

  async subscribeTo1To2EmailsAWeek() {
    const vismaId = this.customerService.selectedCustomer().customer?.vismaId;
    if (vismaId) {
      this.loadingSubscribeToOneToTwoEmailsAWeek.set(true);
      await this.hubspotService.subscribeCustomerToNewsletter(vismaId, false, true);
      this.loadingSubscribeToOneToTwoEmailsAWeek.set(false);
    }
  }

}
